import Vue from 'vue'
import Router from 'vue-router'
import Resource from 'vue-resource'
import Hello from '@/components/Hello'
import Hotel from '@/components/Hotel'
import Addhotel from '@/components/Addhotel'
import Callback from '@/components/Callback'
import Logout from '@/components/Logout'
import Ombrelli from '@/components/Ombrelli'
import Editgrid from '@/components/Editgrid'
import Pool from '@/components/Pool'
import Canvas from '@/components/Canvas'
import ForgotPassword from '@/components/ForgotPassword'
import Pagamenti from '@/components/Pagamenti'

Vue.use(Resource)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/Hotel',
      name: 'Hotel',
      component: Hotel
    },
    {
      path: '/Ombrelli/:hotel',
      name: 'Ombrelli',
      component: Ombrelli
    },
    {
      path: '/Editgrid/:hotel',
      name: 'Editgrid',
      component: Editgrid
    },
    {
      path: '/Canvas/:hotel',
      name: 'Canvas',
      component: Canvas
    },
    {
      path: '/Pool/:hotel',
      name: 'Pool',
      component: Pool
    },
    {
      path: '/pagamenti/:hotel',
      name: 'Pagamenti',
      component: Pagamenti
    },
    {
      path: '/password-forgot/:token',
      name: 'Password-forgot',
      component: ForgotPassword
    },
    {
      path: '/Addhotel',
      name: 'Addhotel',
      component: Addhotel
    },
    {
      path: '/Callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/Logout',
      name: 'Logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js